import {
  getAllCalls as getAllCallsAPI,
  updateCall as updateCallAPI,
  getCall as getCallAPI,
  deleteCall as deleteCallAPI,
  updateChatParticipant as updateChatParticipantAPI,
} from '../api/calls';

import { getKeyMomentTypes as getKeyMomentTypesAPI } from '../api/moments';

export const GET_ALL_CALLS_SUCCESS = 'GET_ALL_CALLS_SUCCESS';
export const GET_ALL_CALLS_FAILURE = 'GET_ALL_CALLS_FAILURE';
export const UPDATE_CALL_SUCCESS = 'UPDATE_CALL_SUCCESS';
export const UPDATE_CALL_FAILURE = 'UPDATE_CALL_FAILURE';
export const GET_CALL_REQUEST = 'GET_CALL_REQUEST';
export const GET_CALL_SUCCESS = 'GET_CALL_SUCCESS';
export const GET_CALL_FAILURE = 'GET_CALL_FAILURE';
export const DELETE_CALL_REQUEST = 'DELETE_CALL_REQUEST';
export const DELETE_CALL_SUCCESS = 'DELETE_CALL_SUCCESS';
export const DELETE_CALL_FAILURE = 'DELETE_CALL_FAILURE';
export const UPDATE_CHAT_PARTICIPANT_REQUEST = 'UPDATE_CHAT_PARTICIPANT_REQUEST';
export const UPDATE_CHAT_PARTICIPANT_SUCCESS = 'UPDATE_CHAT_PARTICIPANT_SUCCESS';
export const UPDATE_CHAT_PARTICIPANT_FAILURE = 'UPDATE_CHAT_PARTICIPANT_FAILURE';
export const GET_KEY_MOMENT_TYPES_SUCCESS = 'GET_KEY_MOMENT_TYPES_SUCCESS';
export const GET_KEY_MOMENT_TYPES_FAILURE = 'GET_KEY_MOMENT_TYPES_FAILURE';

export const getAllCalls = (options = {}) => async (dispatch, getState) => {
  try {
    const resp = await getAllCallsAPI(options);
    return dispatch({
      type: GET_ALL_CALLS_SUCCESS,
      calls: resp.results,
      ...options,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: GET_ALL_CALLS_FAILURE,
      error,
    });
  }
};

export const getCall = (idOrHash) => async (dispatch, getState) => {
  dispatch({ type: GET_CALL_REQUEST, id: idOrHash });
  try {
    const call = await getCallAPI(idOrHash);
    return dispatch({
      type: GET_CALL_SUCCESS,
      call,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: GET_CALL_FAILURE,
      error,
    });
  }
};

export const updateCall = (call, updates) => async (dispatch, getState) => {
  try {
    const newCall = await updateCallAPI(call, updates);
    window.__ADD_EVENT__('Calls - Update Call', { call, ...updates });
    return dispatch({
      type: UPDATE_CALL_SUCCESS,
      call: newCall,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: UPDATE_CALL_FAILURE,
      error,
    });
  }
};

export const deleteCall = (call) => async (dispatch, getState) => {
  dispatch({ type: DELETE_CALL_REQUEST, call });
  window.__ADD_EVENT__('Calls - Delete Call', { call });
  try {
    const callResp = await deleteCallAPI(call);
    return dispatch({
      type: DELETE_CALL_SUCCESS,
      call: callResp,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: DELETE_CALL_FAILURE,
      call,
      error,
    });
  }
};

export const getKeyMomentTypes = () => async (dispatch, getState) => {
  try {
    const types = await getKeyMomentTypesAPI();
    return dispatch({
      type: GET_KEY_MOMENT_TYPES_SUCCESS,
      types,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: GET_KEY_MOMENT_TYPES_FAILURE,
      error,
    });
  }
};

export const updateChatParticipant = (participant, updates) => async (dispatch, getState) => {
  // Can update: name, speaker_type
  dispatch({ type: UPDATE_CHAT_PARTICIPANT_REQUEST, participant, updates });
  window.__ADD_EVENT__('Calls - Update Chat Participant');
  try {
    const newParticipant = await updateChatParticipantAPI(participant, updates);
    return dispatch({
      type: UPDATE_CHAT_PARTICIPANT_SUCCESS,
      participant: newParticipant,
    });
  } catch (error) {
    console.error(error);
    return dispatch({
      type: UPDATE_CHAT_PARTICIPANT_FAILURE,
      error,
    });
  }
};
